import script from "./galleryImage.vue?vue&type=script&setup=true&lang=js"
export * from "./galleryImage.vue?vue&type=script&setup=true&lang=js"

import "./galleryImage.vue?vue&type=style&index=0&id=3b2d1160&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b2d1160"]])

export default __exports__